export default __webpack_public_path__ + "static/media/Ficha Técnica - Maracuja Integral.d98fbf31.pdf";